import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type Patient from "./patient";
import type VitalSignItem from "./vital-sign/vital-sign-item";

//---- Automatically generated, don't update this part ----

type SourceStringEnum = "profiler" | "wise";

export default class ConstantMonitoringChangedJournalEvent extends JournalEvent {
  static override type = "constant-monitoring-changed-journal-event";

  @attr("string") declare source: SourceStringEnum;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.constant-monitoring-changed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      source: validateInclusion({
        list: ["profiler", "wise"],
        allowBlank: true,
        description: intl.t(
          "validations.constant-monitoring-changed-journal-event.source"
        )
      })
    };
  }

  //---- End of generated code ----

  @attr("vital-sign-items", {
    defaultValue() {
      return [];
    }
  })
  declare constants: VitalSignItem[];

  @belongsTo("patient", {
    async: false,
    inverse: "constantMonitoringChangedJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "constant-monitoring-changed-journal-event": ConstantMonitoringChangedJournalEvent;
  }
}
